import React from "react";
import { Row, Col, Typography, Space, Grid } from "antd";
import BusinessImg from "../../assets/images/BusinessImg.svg"; 

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

export default function BusinessSection() {
  const screens = useBreakpoint();

  return (
    <div
      style={{
        background: "#ffffff",
        padding: screens.md ? "96px 24px" : "48px 16px",
      }}
    >
      {/* MAIN CONTAINER */}
      <div
        style={{
          maxWidth: 1128,
          margin: "0 auto",
        }}
      >
        <Row align="middle" gutter={[48, 48]}>
          {/* LEFT CONTENT */}
          <Col xs={24} md={12}>
            <Space direction="vertical" size={16} style={{ width: "100%" }}>
              <Title
                level={2}
                style={{
                  color: "#2d1e6b",
                  fontWeight: 700,
                  lineHeight: 1.25,
                  margin: 0,
                }}
              >
                Scale your business – we got your back
              </Title>

              <Text style={{ fontSize: 15, color: "#2d1e6b" }}>
                • Prepare for traffic surges – try a higher-tier plan with the{" "}
                <strong>free 24-hour plan boost option</strong>.
              </Text>

              <Text style={{ fontSize: 15, color: "#2d1e6b" }}>
                • Adjust your website’s resources up or down with our{" "}
                <strong>scalable web hosting plans</strong>.
              </Text>

              <Text style={{ fontSize: 15, color: "#2d1e6b" }}>
                • Boost online visibility with a{" "}
                <strong>free domain name</strong>, including .com, .net, and 20+
                more extensions.
              </Text>

              <Text style={{ fontSize: 15, color: "#2d1e6b" }}>
                • Enjoy high uptime and speedy content delivery with a{" "}
                <strong>global data center network</strong>.
              </Text>
            </Space>
          </Col>

          {/* RIGHT IMAGE */}
          <Col
            xs={24}
            md={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={BusinessImg}
              alt="Scale Business"
              style={{
                width: "100%",
                maxWidth: 560,
                height: "auto",
                display: "block",
              }}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
}
